import React from 'react';
import Icon from './Icon';
import './IconTextRow.css';

/**
 * Kleine Zeile aus Material-Icon + Text. Tone steuert die Farbe:
 *   - "default" (Default): Sekundärfarbe
 *   - "warn":   negative-color (z.B. „Bereits im Spieltag")
 *   - "info":   accent-color   (z.B. „Wird wiederhergestellt")
 *   - "diff":   warning-color  (Abweichungen)
 *
 * Ersetzt das wiederkehrende `<span style={{display:'flex', ...}}><Icon ... />text</span>`-Pattern.
 */
function IconTextRow({ icon, iconClassName, tone = 'default', bold = false, children }) {
  const cls = [
    'iconTextRow',
    `iconTextRow--${tone}`,
    bold ? 'iconTextRow--bold' : null,
  ].filter(Boolean).join(' ');

  return (
    <span className={cls}>
      <Icon className={iconClassName} icon={icon} />
      <span className="iconTextRowText">{children}</span>
    </span>
  );
}

export default IconTextRow;
